@if (rowData$ | async; as rowData ){
<ng-container *ngFor="let column of rowDisplayColumns; trackBy: trackByFn">
  @if(tableService.getCell(column); as cell){
  <ng-container *ngTemplateOutlet="cell.templateRef; context: { $implicit: rowData, rowIndex: rowIndex }"></ng-container
  >}
</ng-container>
}
